import type { EducationPgmProgram } from "@/types";

const getTestGroupKey = (test: NonNullable<EducationPgmProgram["testHistory"]>[number]): string => {
  if (test.testDefinition?.oldTestId) return test.testDefinition.oldTestId;

  return test.testId.replace(/TEST(?:1|R)$/, "TEST");
};

export const deduplicateTests = (
  tests: NonNullable<EducationPgmProgram["testHistory"]>
): NonNullable<EducationPgmProgram["testHistory"]> => {
  const bestByTestGroup = new Map<string, (typeof tests)[number]>();
  for (const t of tests) {
    const groupKey = getTestGroupKey(t);
    const existing = bestByTestGroup.get(groupKey);
    if (
      !existing ||
      (t.isPassed && !existing.isPassed) ||
      (!existing.isPassed && !t.isPassed && t.attemptNumber > existing.attemptNumber)
    ) {
      bestByTestGroup.set(groupKey, t);
    }
  }
  return Array.from(bestByTestGroup.values());
};
